import React from 'react';
import * as PropTypes from 'prop-types';

import { Spacer } from './elements';

function Spa56(props) {
  return <Spacer className={props.className} />;
}

Spa56.propTypes = {
  className: PropTypes.string,
};

export default Spa56;
